import type { FC } from 'react';

import * as styles from './available-label.css.ts';
import { FormattedMessage } from '../../utils';

interface AvailableLabelProps {
  readonly align?: 'left' | 'center' | 'right';
  readonly available?: number;
  readonly total?: number;
}

export const AvailableLabel: FC<AvailableLabelProps> = ({
  align = 'center',
  available = 1,
  total = 1,
}) => {
  return (
    <div className={styles.container} data-align={align}>
      <span className={styles.label}>
        <FormattedMessage id='packs.available' values={{ available, total }} />
      </span>
    </div>
  );
};
